<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="
            params &&
            params.context &&
            params.context.parentComponent &&
            params.context.parentComponent.permissions &&
            params.context.parentComponent.permissions.change
          "
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="editItem"
          class="mr-2 ml-1"
        >
          mdi-pencil
        </v-icon>
      </template>
      <span>Edit</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="viewItem"
          class="ml-2 mr-1"
        >
          mdi-eye
        </v-icon>
      </template>
      <span>View</span>
    </v-tooltip>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="params?.context?.parentComponent"
          class="ml-2 mr-1"
          :color="is_driver_active === 'No' ? 'grey' : 'primary'"
          :style="{ opacity: is_driver_active === 'No' ? 0.5 : 1 }"
          v-on="on"
          v-bind="attrs"
          @click="changeStatus"
        >
          mdi-toggle-switch
        </v-icon>
      </template>
      <span>Active/ De-active Driver</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  computed: {
    is_driver_active() {
      const status = this.params?.data?.status;
      return status === "Deactivated" ? "No" : "Yes";
    },
  },

  methods: {
    editItem() {
      this.params.context.parentComponent.editDriver(this.params.data.id);
    },
    viewItem() {
      this.params.context.parentComponent.viewDriver(this.params.data.id);
    },
    changeStatus() {
      if (this.params) {
        this.params.context.parentComponent.confirmation(
          this.params.data.id,
          this.is_driver_active == "Yes" ? false : true
        );
      }
    },
  },
};
</script>
